import { createContext, useContext } from 'react';
const CardDataContext = /*#__PURE__*/createContext(undefined);
export const CardDataContextProvider = CardDataContext.Provider;
export function useCardData() {
  const value = useContext(CardDataContext);
  if (!value) {
    throw new Error('useCardData was called outside of a valid CardDataContext.');
  }
  return value;
}